import { atom } from 'jotai';

import { ProcessCreateDialogRequest } from '@/views/processesCreate/model/ProcessCreateDialog.model.ts';

export const processCreateDialogAtom = atom<ProcessCreateDialogRequest | null>(null);
